import { IBondGrossReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_YIELD_SHEKEL';

export type IReportGrossYieldShekelItem = IBondGrossReport & { __isSelected: boolean };
